<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('app.update_title') }}</span>
            <span v-else>{{ $t('app.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('identity_id')">
          <label>{{ $t('app.identity_id') }}</label>
          <treeselect :class="{ 'treeselect-error' : fErr('identity_id') }"
            :placeholder="$t('app.identity_id')" :clearable="false"
            :load-options="audocompleteIdentity" :async="true" :defaultOptions="true"
            v-model="entity.identity_id"/>
          <span class="error-text">{{ fErr('identity_id') }}</span>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('app.name') }}</label>
          <b-form-input type="text" :placeholder="$t('app.name_placeholder')"
            :class="{ 'is-invalid' : fErr('name') }"
            v-model="entity.name"/>
        </b-form-group>

        <b-form-group :invalid-feedback="fErr('domain')">
          <label>{{ $t('app.domain') }}</label>
          <b-form-input type="text" :placeholder="$t('app.placeholders.domain')"
            :class="{ 'is-invalid' : fErr('domain') }"
            v-model="entity.domain"/>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('login_url')">
          <label>{{ $t('app.login_url') }}</label>
          <b-form-input type="text" :placeholder="$t('app.placeholders.login_url')"
            :class="{ 'is-invalid' : fErr('login_url') }"
            v-model="entity.login_url"/>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('login_username')">
          <label>{{ $t('app.login_username') }}</label>
          <b-form-input type="text" :placeholder="$t('app.placeholders.login_username')"
            :class="{ 'is-invalid' : fErr('login_username') }"
            v-model="entity.login_username"/>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('login_data')">
          <label>{{ $t('app.login_data') }}</label>
          <b-form-input type="text" :placeholder="$t('app.placeholders.login_data')"
            :class="{ 'is-invalid' : fErr('login_data') }"
            v-model="entity.login_data"/>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('login_info')">
          <label>{{ $t('app.login_info') }}</label>
          <b-form-input type="text" :placeholder="$t('app.placeholders.login_info')"
            :class="{ 'is-invalid' : fErr('login_info') }"
            v-model="entity.login_info"/>
        </b-form-group>

      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'Passwords' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';
import { mapState } from 'vuex';

import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          identity_id: null,
          name: '',
          domain: '',
          login_url: '',
          login_username: '',
          login_data: '',
          login_info: '',
        };
      },
    },
  },
  components: { Treeselect },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
  },
  methods: {
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? Services.passwords.editData : Services.passwords.createData;
      action(this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.app : { ...this.entity, ...data.data.app };
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? Services.passwords.update : Services.passwords.create;
      action(this.entity).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          this.$router.push({ name: 'Passwords', params: { id: data.data.id } });
        }
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },

    audocompleteIdentity({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        Services.identities.list({ notpaginate: 1, search: searchQuery }).then(({ data }) => {
          const options = data.data.map((i) => ({
            id: i.id, label: `${i.id} ${i.name}`,
          }));
          callback(null, options);
        });
      }
    },
  }
};
</script>

<style scoped>
</style>
